import React from 'react';
import CheckmarkIcon from '../../../../../../../../assets/img/CheckmarkIcon.svg';
import { clearFileStore } from '../../../../../../../../components/FileUpload/FileUpload';

const FormSubmitted = ({ submitSucceeded, reset, clearSingleUploadData, fileProgress, clearUploadProgress }) => {
  const onReset = () => {
    reset();
    clearSingleUploadData();
    clearUploadProgress();
    clearFileStore();
  };

  const progressItems = Object.values(fileProgress || {}).filter(Boolean);
  const uploadsComplete =
    progressItems.length > 0 && progressItems.every((p) => p?.status === 'complete');

  if (submitSucceeded || uploadsComplete) {
    return (
      <div className="result-page">
        <img src={CheckmarkIcon} alt="Success" className="result-icon" />
        <p className="result-message result-message--success">Din leverans har med framgång levererats till mottagaren!</p>
        <button className="btn btn--primary" onClick={onReset}>Skapa en ny leverans</button>
      </div>
    );
  } else {
    return null;
  }
};

export default FormSubmitted;
